﻿
import document from 'document';

export const contactPreferences = () => {
    const selectors = {
        labelGroup: '.form-field-group',
        checkbox: 'input[type="checkbox"]',
        label: 'label',
        selected: '.selected',
        unselected: '.unselected'
    };

    const toggleText = (checkbox, label) => {
        const selectedText = label.querySelectorAll(selectors.selected)[0];
        var unselectedText = label.querySelectorAll(selectors.unselected)[0];

        if (checkbox.checked) {
            unselectedText.style.display = 'none';
            selectedText.style.display = 'block';
        } else {
            selectedText.style.display = 'none';
            unselectedText.style.display = 'block';
        }
    };

    const attachEvents = (root) => {
        const labelGroups = root.querySelectorAll(selectors.labelGroup);
        
        labelGroups.forEach(group => { 
            const checkbox = group.querySelectorAll(selectors.checkbox)[0];
            const label = group.querySelectorAll(selectors.label)[0];
            
            toggleText(checkbox, label);
            checkbox.addEventListener('change', () => {
              toggleText(checkbox, label);
            });
        });
    };

    const init = component => {
        const root = document.getElementById(component.id);
        attachEvents(root);
    };

    return {
        init: init,
        selector: '#marketing-preferences-form'
    };
};